import axiosInstance from "./AxiosInstance";
export const addInwardStockAPI = (data) => {
  return axiosInstance.post("/stock/medicineInward", data);
};

export const getInwardStockListAPI = () => {
  return axiosInstance.post("/stock/inwardList");
};

export const getInwardStockDetailsAPI = (inward_id) => {
  return axiosInstance.post("/stock/inwardDetails", { inward_id });
};

export function deleteInwardStock(data) {
  return axiosInstance.post("/stock/deletemedicineInward", data);
}

// Format inward stock data from API response
export function formatInwardStock(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((inward) => ({
      ...inward,
      inward_id: inward.inward_id || inward._id || inward.id,
    }));
  }

  let inwards = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      inwards.push({
        ...responseData[key],
        inward_id:
          responseData[key].inward_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return inwards;
}

export function formatInwardStockDetails(responseData) {
  if (!responseData) return null;
  
  // If responseData is an array (items directly), format it
  if (Array.isArray(responseData)) {
    // Get branch info from first item (if available)
    const firstItem = responseData[0];
    const branch_name = firstItem?.branch_name || "";
    const inward_id = firstItem?.inward_id || "";
    
    return {
      inward_id: inward_id,
      branch_name: branch_name,
      invoice_no: "",
      total_medicine: responseData.length,
      total_qty: responseData.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0),
      created_at: firstItem?.created_at || "",
      updated_at: firstItem?.updated_at || "",
      scanqrcodedata: responseData.map((item) => ({
        medicine_id: item.medicine_id,
        medicine_name: item.medicine_name,
        batch_no: item.batch_no,
        carton_id: item.carton_id,
        mfg_date: item.mfg_date,
        qty: item.qty,
        inward_item_id: item.inward_item_id,
      })),
    };
  }
  
  // If responseData is an object with data property
  if (responseData.data && Array.isArray(responseData.data)) {
    const items = responseData.data;
    const firstItem = items[0];
    
    return {
      inward_id: firstItem?.inward_id || "",
      branch_name: firstItem?.branch_name || "",
      invoice_no: "",
      total_medicine: items.length,
      total_qty: items.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0),
      created_at: firstItem?.created_at || "",
      updated_at: firstItem?.updated_at || "",
      scanqrcodedata: items.map((item) => ({
        medicine_id: item.medicine_id,
        medicine_name: item.medicine_name,
        batch_no: item.batch_no,
        carton_id: item.carton_id,
        mfg_date: item.mfg_date,
        qty: item.qty,
        inward_item_id: item.inward_item_id,
      })),
    };
  }
  
  return null;
}